/**
 * Dependencies.
 */
import { RouteConfig } from 'vue-router';

// import { ROUTES } from '@/constants/routes.constant';

/**
 * Export.
 */
export default [
  {
    beforeEnter: () => {
      window.location.href = `/apps/dashboard${window.location.search}`;
    },
    // component: () =>
    //   import(
    //     /* webpackChunkName: "dashboard" */ '@/modules/dashboard/scenes/dashboard.scene.vue'
    //   ),
    meta: { requiresAuth: true },
    // name: ROUTES.DASHBOARD.DASHBOARD,
    path: 'dashboard'
  }
] as RouteConfig[];
